import { AppRoutes } from '@constants/app-routes'
import { OrangeLink } from '@ui/links/OrangeLink'

const baseUrl = '/images/cases/smart-platform'

export const config = {
  headerTitle: 'Project execution',
  hexagonGrayFilled: {
    width: 420,
    height: 420,
    src: `${baseUrl}/hexagonGrayFilled.webp`,
    alt: 'Hexagon',
    title: 'Hexagon',
  },
  cards: [
    {
      id: 1,
      isRowReverse: true,
      textWidth: 664,
      title: 'Collaborative approach',
      text: 'At Modsen we understand that a collaborative approach is crucial for the augmentation specialists to seamlessly integrate with the client’s in-house team. It enables effective communication, promotes leveraging of each other`s strengths, and fosters a cohesive work environment. To ensure that, Modsen experts interacted with the rest of the team via our partner’s communication channel Slack to participate in daily, weekly, and retrospective calls, and to constantly keep in touch with the partner while working toward a common goal. ',
      image: {
        src: `${baseUrl}/svg/collaborative-approach.svg`,
        alt: 'Educational management software interface',
        title: 'Educational management software interface',
        width: 255,
        height: 255,
      },
      imageMobile: {
        src: `${baseUrl}/svg/collaborative-approach.svg`,
        alt: 'Collaborative software development approach',
        title: 'Collaborative software development approach',
        width: 255,
        height: 255,
      },
    },
    {
      id: 2,
      isRowReverse: false,
      textWidth: 664,
      title: 'Domain expertise',
      text: 'Delving into education software development, our dedicated team of EdTech engineers was ready to share valuable insights into industry trends, best practices, and user requirements. Their competencies helped streamline the development process and ensured that the software was relevant, functional, and aligned with the latest industry standards. ',
      image: {
        src: `${baseUrl}/svg/domain-expertise.svg`,
        alt: 'Domain expertise',
        title: 'Domain expertise',
        width: 256,
        height: 255,
      },
      imageMobile: {
        src: `${baseUrl}/svg/domain-expertise.svg`,
        alt: 'Domain expertise',
        title: 'Domain expertise',
        width: 256,
        height: 255,
      },
    },
    {
      id: 3,
      isRowReverse: true,
      textWidth: 664,
      title: 'Flexibility',
      text: (
        <>
          One of many benefits{' '}
          <OrangeLink href={AppRoutes.portfolio}>
            Modsen IT staff augmentation services
          </OrangeLink>{' '}
          can can boast is the agility and adaptability of our crew. Having
          strengthened dozens of in-house teams, we learned how to quickly
          adjust to changing priorities, accommodate new features or
          functionalities, and align our work with the team's workflow. The
          extensive experience and dedication to helping our partners achieve
          their business goals allowed us to seamlessly incorporate into the
          client’s team causing zero disruptions and boosting the project’s
          dynamics. Modsen augmentation team also managed to copy the style of
          code and technical documentation writing, accepted by the partner
          company specialists.
        </>
      ),
      image: {
        src: `${baseUrl}/svg/flexibility.svg`,
        alt: 'Software development flexebility',
        title: 'Software development flexebility',
        width: 249,
        height: 263,
      },
      imageMobile: {
        src: `${baseUrl}/svg/flexibility.svg`,
        alt: 'Software development flexebility',
        title: 'Software development flexebility',
        width: 249,
        height: 263,
      },
    },
    {
      id: 4,
      isRowReverse: false,
      textWidth: 664,
      title: 'Scalability',
      text: (
        <>
          During the initial phase of the education platform development, the
          client decided to welcome 4 Modsen EdTech experts but as the process
          was unrolling, it became clear that another 2{' '}
          <OrangeLink href={AppRoutes.netPage}>.NET specialists</OrangeLink>{' '}
          were urgently needed. The ability to immediately scale up the project
          team allowed for efficient workload management and timely completion
          of its milestones. Scalability enabled our joint team to meet
          increasing demands, handle new challenges, and adapt to evolving
          project scopes.
        </>
      ),
      image: {
        src: `${baseUrl}/svg/scalability.svg`,
        alt: 'Software development scalability',
        title: 'Software development scalability',
        width: 249,
        height: 263,
      },
      imageMobile: {
        src: `${baseUrl}/svg/scalability.svg`,
        alt: 'Software development scalability',
        title: 'Software development scalability',
        width: 249,
        height: 263,
      },
    },
    {
      id: 5,
      isRowReverse: true,
      textWidth: 664,
      title: 'Versatility',
      text: (
        <>
          One of the requirements our partner put forward before hiring Modsen
          coding aces was their versatility. Universal coders with broader tech
          stack and domain experience are highly sought-after as hiring such
          specialists appears to be more effective.{' '}
          <OrangeLink href={AppRoutes.partnership}>At Modsen</OrangeLink>, we
          are focusing on raising full-stack developers able to solve a wide
          range of challenges and significantly contribute to bridging expertise
          gaps for a variety of business verticals.
        </>
      ),
      image: {
        src: `${baseUrl}/svg/versatility.svg`,
        alt: 'Software development versability',
        title: 'Software development versability',
        width: 256,
        height: 255,
      },
      imageMobile: {
        src: `${baseUrl}/svg/versatility.svg`,
        alt: 'Software development versability',
        title: 'Software development versability',
        width: 256,
        height: 255,
      },
    },
  ],
}
